(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
jQuery(document).on('click', 'body#a-1-uniform-city-embroidery button.button.product_type_simple.add_to_cart_button.add-to-cart.ajax_add_to_cart', function() {
    setTimeout(function() {
        location.reload(); // reloads the page
    }, 2000); // 2000ms = 2 seconds
});

  } catch(e) { console.error(e); }
})();
})();
